/* eslint-disable react/no-unknown-property */
/* eslint-disable react/button-has-type */
import React, { useState } from 'react';
import ReactDatePicker from 'react-datepicker';
import moment from 'moment';
import { Modal, Select } from 'antd-v5';
import { useQuery } from 'react-query';
import { Link } from 'react-router-dom';
import DropdownSelect from '../../../../../../../Layout/DropdownSelect';
import { postRequest, getRequest } from '../../../../../../../../core/apiRequests';
import NumberInput from '../../../../../../../Layout/NumberInput';
import { notificationError } from '../../../../../../../../core/actions';

const renderAssociateOption = option => (
  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
    <span>{option.label}</span>
    <Link
      to={`/Associates/associate-details/${option.value}`}
      onClick={e => e.stopPropagation()}
      onMouseDown={e => e.stopPropagation()}
      style={{ marginLeft: '8px', fontSize: '12px' }}
    >
      View
    </Link>
  </div>
);

const EditOppModalWithNotes = props => {
  const { salesOpp, setSalesOpp, stageList, currentUserId, currentUserRole, salesOppOwnerId } = props;
  const [opp, setOpp] = useState(salesOpp);
  const [expectedCloseDate, setExpectedCloseDate] = useState(
    new Date(moment(opp.close_date, 'YYYYMMDD').format('YYYY-MM-DDTHH:mm:ssZ')),
  );
  const [notesText, setNotesText] = useState(props.salesOpp.notes);
  const [selectedOwnerId, setSelectedOwnerId] = useState(salesOpp.associate_id);

  
  const canChangeOwner =
    currentUserId === salesOppOwnerId || currentUserRole === 'ADMIN' || currentUserRole === 'MANAGER';

  const { data: associateOptions } = useQuery(
    ['associates-edit-opp-modal-v2'],
    async () => {
      const reqObj = { params: ['associates'], loadingStatusOff: true };
      const data = await getRequest(reqObj);
      return (data || [])
        .sort((a, b) => (`${a.first_name}${a.last_name}` > `${b.first_name}${b.last_name}` ? 1 : -1))
        .map(a => ({ value: a.id, label: `${a.first_name || ''} ${a.last_name || ''}`.trim() }));
    },
    { enabled: canChangeOwner, refetchOnWindowFocus: false, initialData: [] },
  );

  const onSaveHandler = () => {
    const new_close_date = moment(expectedCloseDate).format('YYYYMMDD');
    setOpp({ ...opp, close_date: new_close_date });
    const { name, amount, close_date, sales_opp_stage_id, id } = opp;
    if (props.merchantId && expectedCloseDate) {
      setSalesOpp(opp);
      // here
      const bodyData = {
        client_id: props.client_id,
        associateId: props.associateId,
        store_id: props.store_id,
        pipelineName: name,
        priceValue: amount,
        expectedCloseDate: moment(expectedCloseDate).format('YYYYMMDD'),
        merchantId: props.merchantId,
        firstName: props.firstName,
        lastName: props.lastName,
        sales_opp_stage_id,
        sales_opp_id: id,
        notes: notesText,
        ownerAssociateId: selectedOwnerId,
      };
      const reqObj = {
        params: ['clients', props.merchantId, opp.id, 'saveAndUpdateSalesOpp'],
        query: { createdBy: 1 },
        data: bodyData,
        delay: 2500,
      };

      (async () => {
        await postRequest(reqObj);
        const newStageName = stageList.filter(stage => stage.id === sales_opp_stage_id);
        const updatedOpp = {
          ...salesOpp,
          ...opp,
          stage_name: newStageName[0]?.name ?? salesOpp.stage_name,
          close_date,
          associate_id: selectedOwnerId,
        };
        props.setSalesOpp(updatedOpp);
        props.showEditOppModalHandler();

        if (typeof props.onSuccess === 'function') {
          props.onSuccess(updatedOpp);
        }
      })();
    } else if (!expectedCloseDate) {
      notificationError('Please set a close date');
    }
  };

  return (
    <Modal
      title="Edit Sales Opportunities"
      open
      onCancel={props.showEditOppModalHandler}
      onOk={onSaveHandler}
      okText="Save"
      destroyOnClose
      width={404}
      centered
    >
      <div className="m-top-15">
        <input
          value={opp.name}
          onChange={e => setOpp({ ...opp, name: e.target.value })}
          className="w-100-P"
          style={{
            height: '50px',
            borderRadius: '3px',
            border: '1px solid #818181',
            boxSizing: 'border-box',
            paddingLeft: '16px',
          }}
          placeholder="Choose an opportunity..."
        />
        <div className="w-100-P m-top-15">
          <NumberInput
            decorator="$"
            min="0"
            step={1}
            precision={1}
            placeholder="1000"
            onChange={e => {
              if (e?.target) {
                const cleanedNumber = e.target.value.replace(/\D/g, '');
                setOpp({ ...opp, amount: cleanedNumber });
              } else {
                const cleanedNumber = e.toString().replace(/\D/g, '');
                setOpp({ ...opp, amount: cleanedNumber });
              }
            }}
            value={opp.amount}
          />
        </div>
        <div className="m-top-20">
          <p
            style={{
              fontWeight: 500,
              fontSize: '14px',
              margin: '0',
              textAlign: 'left',
              width: '100%',
            }}
          >
            Expected Close Date
          </p>
          <ReactDatePicker
            selected={expectedCloseDate}
            onChange={date => {
              setExpectedCloseDate(date);
            }}
            customInput={
              <input
                className="w-100-P m-top-13"
                style={{
                  height: '50px',
                  borderRadius: '3px',
                  border: 'solid 1px #818181',
                  paddingLeft: '16px',
                  boxSizing: 'border-box',
                  fontSize: '14px',
                }}
              />
            }
          />
        </div>

        <div className="m-top-9">
          <p
            style={{
              fontWeight: 500,
              fontSize: '14px',
              margin: '0',
              textAlign: 'left',
              width: '100%',
            }}
          >
            Stage
          </p>

          <DropdownSelect
            classProps="w-100-P m-top-13"
            placeholder="Choose an opportunity..."
            value={opp.sales_opp_stage_id}
            options={stageList.map(stage => ({
              value: stage.id,
              label: stage.name,
            }))}
            onChange={val => setOpp({ ...opp, sales_opp_stage_id: val.value })}
          />
        </div>

        {canChangeOwner && (
          <div className="m-top-9">
            <p
              style={{
                fontWeight: 500,
                fontSize: '14px',
                margin: '0',
                textAlign: 'left',
                width: '100%',
              }}
            >
              Owner
            </p>
            <Select
              className="w-100-P m-top-13"
              style={{ height: '50px' }}
              placeholder="Select an associate..."
              value={selectedOwnerId}
              options={associateOptions}
              onChange={val => setSelectedOwnerId(val)}
              showSearch
              filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
              optionRender={renderAssociateOption}
            />
          </div>
        )}

        <div className="m-top-9">
          <p
            style={{
              fontWeight: 500,
              fontSize: '14px',
              margin: '0',
              textAlign: 'left',
              width: '100%',
            }}
          >
            Opportunity Notes
          </p>
          <textarea
            placeholder="Opportunity notes..."
            className="w-100-P m-top-13"
            style={{
              height: '130px',
              border: 'solid 1px #818181',
              borderRadius: '3px',
              resize: 'none',
              boxSizing: 'border-box',
              padding: '12px',
            }}
            value={notesText}
            onChange={e => setNotesText(e.target.value)}
            maxLength={10000}
          />
        </div>
      </div>
    </Modal>
  );
};

export default EditOppModalWithNotes;
